module Meevo.Plugins.Egifts {
    'use strict';

    import SortDirection = Meevo.Model.SortDirection;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;
    import EgfitCommunicationTypeEnum = Meevo.Plugins.Egifts.EgfitCommunicationTypeEnum;
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import SaleStateEnum = Meevo.Model.SaleStateEnum;
    import SalesTypeEnum = Meevo.Model.SalesTypeEnum;

    export class TransactionsSection extends EgiftsBaseSection {
        public transactionNotes: any;
        protected modifiedTransactionLines: Array<any> = [];
        protected currentGcId: string;
        protected currentItemId: string;
        public isEdit: boolean = false;
        public transItemCopy: EgiftTransactionsSection.ITransaction;
        public isViewNotes: boolean = false;
        public notesRequestData: any;
        public sortItem: EgiftTransactionsSection.ISortCategories = { sortBy: 'dateCreated', label: 'LABEL_NEWEST_PURCHASE', sortDirection: SortDirection.Descending };

        public deliveryMethods: Array<EgiftTransactionsSection.IDeliveryMethods> = this.deliveryMethodsData;
        public emailDeliveryStatuses: Array<EgiftTransactionsSection.IEmailDeliveryStatuses> = this.emailDeliveryStatusesData;
        public mailDeliveryStatuses: Array<EgiftTransactionsSection.IMailDeliveryStatuses> = this.mailDeliveryStatusesData;
        public pickupDeliveryStatuses: Array<EgiftTransactionsSection.IPickupDeliveryStatuses> = this.pickupDeliveryStatusesData;
        public consumMailPickupStatus: Array<EgiftTransactionsSection.IConsumMailPickupStatus> = [
          ...this.mailDeliveryStatuses,
          ...this.pickupDeliveryStatuses
        ];
        public sortCategories: Array<EgiftTransactionsSection.ISortCategories> = this.sortCategoriesData;

        disableCrud: boolean = true;
        disableInitialRequest: boolean = false;
        loadPager: boolean = false;
        isFilterActive: boolean = false;
        isSingleLocation: boolean;
        identitySvc: any;
        dateToday: Date = moment().toDate();
        private isModeCO: boolean;
        public selectedDeliveryMethod: any = null;
        public selectedDeliveryStatus: any;
        public enableAutoGenerateGiftCardNumberButton: boolean;
        public noteNewText: string;
        protected notesEndPoint: string = 'Note';
        public locationEmail: string;
        public requireClientToSelectLocation: boolean;
        public location: any;
        public selectedLocationId: number;
        public servicesPackagesLimitTo: number = 10;
        public servicesPackages: Array<any> = [];
        private minServicesPackages: number = 10;

        public transactionsInfiniteList: Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
        public request: EgiftTransactionsSection.ITransactionRequest = this.defaultRequest;
        public selectedAccordion
        public selectedAccordionIndex: number;
        public isEmptyList = false;
        public isMobileView = false;

        constructor(params: ISectionParamsEgifts,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $mdDialog: ng.material.IDialogService,
            protected $scope: angular.IScope,
            protected $q: angular.IQService,
            protected translate: angular.translate.ITranslateService,
            protected securityChecker: Meevo.Components.Common.ISecurityService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: ng.IRootScopeService) {
            super(params);
            this.identitySvc = <any>this.identityService;

            this.isModeCO = this.identitySvc.inCentralOfficeMode();
            this.isSingleLocation = this.identitySvc.identity.isSingleLocation;

            this.checkMobileView(this);

        }

        checkMobileView(self) {
            this.isMobileView = this.isMobile()

            angular.element(window).on('resize', () => {
                self.$scope.$apply(() => {
                    self.isMobileView = window.matchMedia("(max-width: 768px)").matches;
                });
            });
        }

        expandCallback(indexToOpen: number, accordionToOpen): void {
            const transItem: any = this.transactionsInfiniteList.getItemAtIndex(indexToOpen);
            if (transItem) {
                this.transItemCopy = angular.copy(transItem);
                if (transItem.servicePackagesJSON) {
                    this.servicesPackagesLimitTo = this.minServicesPackages;
                    this.servicesPackages = JSON.parse(transItem.servicePackagesJSON);
                }
            }
            if (this.selectedAccordion && this.selectedAccordionIndex !== indexToOpen) {
                this.selectedAccordion.collapseAll();
            }
            this.selectedAccordion = accordionToOpen;
            this.selectedAccordionIndex = indexToOpen;
             
        }

        selectDeliveryMethod(item) {
            this.selectedDeliveryMethod = item;
            this.selectedDeliveryStatus = null;
            switch (this.selectedDeliveryMethod.value) {
                case this.deliveryMethodEnum.EMail:
                    this.selectedDeliveryStatus = this.emailDeliveryStatuses;
                    break;
                case this.deliveryMethodEnum.StorePickup:
                    this.selectedDeliveryStatus = this.pickupDeliveryStatuses;
                    break;
                case this.deliveryMethodEnum.Mail:
                    this.selectedDeliveryStatus = this.mailDeliveryStatuses;
                    break;
                default:
                    this.selectedDeliveryStatus = null;
            }
        }

        process(): void {
            if (this.context.merchantLocationId !== undefined) this.setStateMode(this.context.merchantLocationId);

            this.busyService.start();
            this.egiftsService.getSettings().then(data => {
                const isSelectLocationAndCurrentLocationIsNotSelected = data.settings.requireClientToSelectLocation && !data.settings.selectedLocationWillReceiveFundsFromEgiftSales && data.settings.locationId !== this.identitySvc.locationId;
                const isSelectLocationAndLocationReceiveFunds = data.settings.requireClientToSelectLocation && data.settings.selectedLocationWillReceiveFundsFromEgiftSales;

                if (!this.isSingleLocation && (isSelectLocationAndCurrentLocationIsNotSelected || isSelectLocationAndLocationReceiveFunds)) {
                    this.selectedLocationId = this.identitySvc.locationId;
                }

                this.requireClientToSelectLocation = data.settings.requireClientToSelectLocation;

                this.enableAutoGenerateGiftCardNumberButton = data.enableAutoGenerateGiftCardNumberButton;
                this.setStateMode(data.settings.locationId);
            }).finally(() => this.busyService.stop());
        }

        setStateMode(merchantLocationId) {
            if (merchantLocationId !== this.identitySvc.locationId) {
                if (!this.requireClientToSelectLocation) {
                    this.disableInitialRequest = true;
                }
            }

            this.loadPager = true;
        }

        addRequestLocation(location): void {
            if (!location) return; 
            this.selectedLocationId = location.locationId;
            this.request.criteria.locationId = location.locationId;
            this.location = { ...location };
            
            this.selectedLocationId = null;
        }

        getData() {
            let request: EgiftTransactionsSection.ITransactionRequest = this.getRequest(),
                url: string = this.baseEndpoint + "/" + this.sectionEndpoint;

            this.busyService.start();
            this.transactionsInfiniteList = this.getResults(url, this.onGetData.bind(this), false);
            this.transactionsInfiniteList.initSearch(request);

            if (!this.isModeCO) { return this.process(); }

            this.loadPager = true;
            this.enableAutoGenerateGiftCardNumberButton = (<MainSection>_.first(this.context.sections)).enableAutoGenerateGiftCardNumberButton;
        }

        private getRequest(): any {
            let request: EgiftTransactionsSection.ITransactionRequest = angular.copy(this.request);

            return request;
        }

        onGetData(pageNumber, loadedPages): void {
            this.busyService.stop();
            this.isEmptyList = !pageNumber && !loadedPages.length
        }

        collapseCallback(index, id): boolean {
            if (this.isEdit) {
                return false;
            }
        }

        checkIfCanCollapse(evt: any, pane: any): void {
            if (this.isEdit) {
                evt.preventDefault();
                evt.stopPropagation();
            } else {
                pane.toggle();
            }
        }

        editTransaction(transItem: EgiftTransactionsSection.ITransaction, $pane: any): any {
            if (transItem.saleState == this.saleStateEnum.Void) return;
            if (this.isEdit) return false;

            if (!$pane.isExpanded()) $pane.expand();

            this.modifiedTransactionLines = [];
            this.isEdit = true;

            if (!transItem.clientId) return this.useAnonymousClient(transItem);

            transItem.purchasedForClient = {
                id: transItem.clientId,
                clientType: Model.ClientTypeEnum.Client,
                displayName: transItem.clientDisplayName
            };
            
        }

        cancelEdit(transItem: EgiftTransactionsSection.ITransaction, index: number): any {
            this.modifiedTransactionLines = [];
            const pageNumber = Math.trunc(index / this.defaultRequest.itemsPerPage);
            const indexOnPage = index - (pageNumber * this.defaultRequest.itemsPerPage);

            (<any>this.transactionsInfiniteList).loadedPages[pageNumber][indexOnPage] = this.transItemCopy;
            this.isEdit = false;
        }

        saveTransaction(transItem: EgiftTransactionsSection.ITransaction, index: number): void {
            let commonPromise = this.$q.resolve();

            transItem.isUpdateNumber = this.isGenerateCGNumber(transItem);
            if (transItem.deliveryMethodEnum !== DeliveryMethodEnum.EMail && (transItem.barCode || transItem.isAutoGenerateNumber))
                transItem.giftCardNumber = transItem.barCode;
            if (transItem.isAutoGenerateNumber) delete transItem.giftCardNumber;

            this.busyService.start();
            this.egiftsService.updateTransaction(transItem)
                .then(updateResponse => {
                    if (transItem.deliveryMethodEnum !== DeliveryMethodEnum.EMail) {
                        this.busyService.stop();

                        return this.presaveModalConfirm(transItem, commonPromise).then(changeStatus => {
                            if (changeStatus) {
                                transItem.isUpdateNumber = false;
                                transItem.entityVersion = updateResponse.entityVersion;

                                this.busyService.start();
                                return this.egiftsService.updateTransaction(transItem);
                            } else {
                                return updateResponse;
                            }
                        })
                    } else {
                        return updateResponse;
                    }
                })
              .then((transaction: any) => {
                  this.transItemCopy = angular.copy(transItem);

                  const pageNumber = Math.trunc(index / this.defaultRequest.itemsPerPage);
                  const indexOnPage = index - (pageNumber * this.defaultRequest.itemsPerPage);
                  (<any>this.transactionsInfiniteList).loadedPages[pageNumber][indexOnPage] = transaction;

                  this.isEdit = false;
                  return this.resendOnSave(transItem.eGiftId, transItem.deliveryStatusEnum, transaction.locationId, transItem.isPromotionalGiftCard);
                })
              .finally(() => this.busyService.stop());
        }

        presaveModalConfirm(transItem: EgiftTransactionsSection.ITransaction, commonPromise: ng.IPromise<any>): ng.IPromise<any> {

            if (transItem.barCode || transItem.isAutoGenerateNumber) {
                let modalText = 'MESSAGE_WOULD_UPDATE_PICKUP_STATUS';

                if (transItem.deliveryMethodEnum === DeliveryMethodEnum.Mail) modalText = 'MESSAGE_WOULD_UPDATE_SHIP_STATUS';

                commonPromise = this.modalService.confirm(modalText, ModalTranslationModes.Translate, true, { modalClass: 'modal-alert'}, true).then(isAnswerYes => {
                    if (isAnswerYes)
                        transItem.deliveryStatusEnum = transItem.deliveryMethodEnum === DeliveryMethodEnum.Mail ? EgiftMailDeliveryStatusEnum.ReadyToShip : EgiftPickupDeliveryStatusEnum.ReadyForPickup;

                    return isAnswerYes;
                });
            }

            let deliveryStatusNew = transItem.deliveryMethodEnum === DeliveryMethodEnum.Mail ? EgiftMailDeliveryStatusEnum.New : EgiftPickupDeliveryStatusEnum.New;

            if (this.transItemCopy.deliveryStatusEnum !== deliveryStatusNew && transItem.deliveryStatusEnum === deliveryStatusNew) {
                const previousStatus = (<any>this.consumMailPickupStatus).find(item => item.value === this.transItemCopy.deliveryStatusEnum);
                const confrimText = this.translate.instant('MESSAGE_CHANGE_STATUS_IN_TRANSACTION', { oldStatus: this.translate.instant(previousStatus.label) });

                commonPromise = this.modalService.confirm(confrimText, ModalTranslationModes.DoNotTranslate, true, { modalClass: 'modal-alert' }, true).then(isAnswerYes => {
                    if (!isAnswerYes) transItem.deliveryStatusEnum = previousStatus.value;
                    return isAnswerYes;
                });
            }

            return commonPromise;
        }

        // isPromotionalGiftCard selects the promotional shipped template when a mailed promo card is marked as shipped.
        resendOnSave(giftCardId: Guid, deliveryStatus: EgiftPickupDeliveryStatusEnum | EgiftMailDeliveryStatusEnum, locationId: number, isPromotionalGiftCard?: boolean): angular.IPromise<any> {
            if (deliveryStatus == EgiftPickupDeliveryStatusEnum.ReadyForPickup || deliveryStatus == EgiftMailDeliveryStatusEnum.Shipped) {
                let type: EgfitCommunicationTypeEnum;
                if (deliveryStatus == EgiftPickupDeliveryStatusEnum.ReadyForPickup) {
                    type = EgfitCommunicationTypeEnum.EgiftPurchaserEmailForReadyToPickup;
                } else {
                    type = isPromotionalGiftCard
                        ? EgfitCommunicationTypeEnum.PromoCardShippedEmail
                        : EgfitCommunicationTypeEnum.EgiftShippedEmail;
                }

                return this.egiftsService.resendTransaction({ giftCardId, type: <EgfitCommunicationTypeEnum>type });
            }

            return this.$q.resolve({});
        }

        createNewTransactionNote() {
            return this.$q.resolve({});
        }

        getCriteriaForNotes() {
            return {
                EgiftId: this.currentGcId,
                objectState: Meevo.Model.ObjectStateEnum.Active
            };
        }

        openNotes(giftCardId: string, itemId: string): void {
            this.isViewNotes = true;
            this.isEdit = false;
            this.currentGcId = giftCardId;
            this.currentItemId = itemId;
        }

        // Selects the correct communication type for manual resends, routing promo cards to PromoCard* templates.
        public prepareesendTransaction(giftCard, resendToSender: boolean): any {
            const isPromo = !!giftCard.isPromotionalGiftCard;
            let communicationTypeEnum: EgfitCommunicationTypeEnum = null;
            switch (giftCard.deliveryMethodEnum) {
                case DeliveryMethodEnum.EMail:
                    if (resendToSender) {
                        communicationTypeEnum = isPromo
                            ? EgfitCommunicationTypeEnum.PromoCardPurchaserEmail
                            : EgfitCommunicationTypeEnum.EgiftPurchaserEmail;
                    } else {
                        communicationTypeEnum = isPromo
                            ? EgfitCommunicationTypeEnum.PromoCardRecipientEmail
                            : giftCard.saleTypeEnum == SalesTypeEnum.GiftCard
                                ? EgfitCommunicationTypeEnum.EgiftRecipientEmail
                                : EgfitCommunicationTypeEnum.EgiftRecipientEmailPackage;
                    }
                    break;
                case DeliveryMethodEnum.Mail:
                    communicationTypeEnum = resendToSender
                        ? (isPromo ? EgfitCommunicationTypeEnum.PromoCardPurchaserEmailForMail : EgfitCommunicationTypeEnum.EgiftPurchaserEmailForMail)
                        : (isPromo ? EgfitCommunicationTypeEnum.PromoCardShippedEmail : EgfitCommunicationTypeEnum.EgiftShippedEmail);
                    break;
                case DeliveryMethodEnum.StorePickup:
                    communicationTypeEnum = isPromo
                        ? EgfitCommunicationTypeEnum.PromoCardPurchaserEmailForPickUp
                        : EgfitCommunicationTypeEnum.EgiftPurchaserEmailForPickUp;
                    break;
                default:
                    break;
            };

            const request = { giftCardId: giftCard.eGiftId, type: communicationTypeEnum, locationId: giftCard.locationId };
            this.resendTransaction(request);
        }

        resendTransaction(request: EgiftTransactionsSection.IprepareesendTransactionReq): void {
            this.busyService.start();
            this.egiftsService.resendTransaction(request).finally(() => this.busyService.stop());
        }

        onResendClicked(giftCard: any, resendToSender: boolean): any {
            const person = this.translate.instant(resendToSender ? 'LABEL_PURCHASER_ORDER_CONFIRMATION' : 'LABEL_RECIPIENT');
            const confrimText = this.translate.instant('MESSAGE_EGIFT_RESEND', { person: person.toLowerCase() });
            this.modalService.confirmHandler(confrimText).then((isAnswerYes: boolean) => {
                if (isAnswerYes) this.prepareesendTransaction(giftCard, resendToSender);                   
            });
        }

        //Opens a modal for transcation audit details
        viewTransactionAudit(transactionId: Guid, locationId: Guid): any {
            let modalScope = this.$scope.$new(true);

            this.busyService.start();
            this.egiftsService.getGiftCardAudit(transactionId, locationId)
                .then((auditInfo) => modalScope['auditHistory'] = auditInfo)
                .finally(() => this.busyService.stop());

            this.showModal(modalScope, 'transactionAudit.html');
        }

        //Open note modal  
        //showAddNoteModal(): void {
        //    let modalScope = this.$scope.$new(true);
        
        //    modalScope['saveNote'] = this.saveNote.bind(this);
        //    this.showModal(modalScope, 'noteAddTemplate.html');
        //}

        locationNotify(giftCard: any): void {
            let modalScope = this.$scope.$new(true);
            let locationId: number = giftCard.selectedLocationId !== undefined ? giftCard.selectedLocationId : giftCard.locationId;

            this.egiftsService.getEmail(locationId).then((data) => {
                this.locationEmail = data.emailAddress;
                let locationEmailAddress = data.emailAddress;

                modalScope['sentLocation'] = this.sentLocation.bind(this);
                modalScope['data'] = { giftCard, locationEmailAddress };
                modalScope['emailPattern'] = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

                this.showModal(modalScope, 'resendToLocation.template.html');
            });
        }

        prepareNoteRequest(note: EgiftTransactionsSection.INote, isNoteUpdated: boolean) {
            if (isNoteUpdated) {
                this.notesRequestData = note;
            } else {
                this.notesRequestData = {
                    objectState: Meevo.Model.ObjectStateEnum.Active
                }
            }
        }

        public sentLocation(giftCardId: any, email: string) {
            this.locationEmail = email;

            const body = {
                giftCardId: giftCardId.eGiftId,
                type: EgfitCommunicationTypeEnum.EgiftLocationEmail,
                email: email,
                selectedLocationId: giftCardId.selectedLocationId,
                locationId: giftCardId.locationId
            };

            this.resendTransaction(body);
            this.closeModal();
        }

        editNote(note: EgiftTransactionsSection.INote) {
            this.noteNewText = note.note;
            note.isEditingMode = true;
        }

        //updateNote(note: EgiftTransactionsSection.INote) {
        //    this.busyService.start();
        //    note.note = this.noteNewText;
        //    this.egiftsService.updateNote(note, this.currentGcId)
        //        .then(() => note.isEditingMode = false )
        //        .finally(() => this.busyService.stop());
        //}

        setNoteEndpoint(note: EgiftTransactionsSection.INote) {
            if (note) {
                this.notesEndPoint = `Note/${note['id']}`;
            } else {
                this.notesEndPoint = 'Note';
            }
        }

        advancedFilter(): void {
            let modalScope = this.$scope.$new(false);

            this.showModal(modalScope, 'transaction.advFilters.html');
        }

        showModal(modalScope: ng.IScope, templateName: string): void {
            modalScope['closeModal'] = this.closeModal.bind(this);

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/egifts/sectionViews/modal/' + templateName,
                scope: modalScope
            }

            this.modalService.showCustom(options);
        }

        expandResend(event, isExpanded, $mdMenu, item?: any ): void {
            if (item.isRefund || item.saleState == SaleStateEnum.Void) {
                this.warningDisableInput(item);
                return;
            }

            $mdMenu.open(event);
            this.isEdit = false;
            if (isExpanded) event.stopPropagation();
        }

        closeModal(): void {
            this.$mdDialog.cancel();
        };

        clearSearch(): void {
            this.location = null;
            this.isFilterActive = false;

            this.closeModal();
            this.request.criteria = this.defaultRequest.criteria
        }

        /**
         * Open selected transaction in Transaction Editor
         * @param {string} transactionNumber
         * @param {number} locationId
         */
        openTransactionEditorTransEditor(transactionNumber: string, locationId: number): void {
            if (!transactionNumber || transactionNumber === "N/A") return;

            if (locationId !== this.identitySvc.locationId) {
                this.modalService.alert("MESSAGE_TRANSACTION_AT_ANOTHER_LOCATION", Components.Modal.ModalTranslationModes.Translate);
                return;
            }

            // Build params for loading transaction in editor
            let stateParams = {
                transactionId: Number(transactionNumber),
                includeActive: true,
                includeCompleted: true,
                includeOnHold: false,
                includeRefunded: true,
                includeVoided: true
            };
            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: stateParams
            });
        }

        openClient(clientId: string): void {

            if (!clientId) return;

            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: {
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    callback: null,
                    callbackState: "appointmentBook",
                    id: clientId,
                    initialEditSection: "SECTION_CLIENT_MAIN",
                }
            });
        }

        // Virtual method to interact with paging functionality
        forcePageLoading(criteria: any): void { }

        getDeliveryMethods(deliveryMethod: DeliveryMethodEnum): string {
            if (!deliveryMethod) return;
            return this.deliveryMethods.find(item => item.value === deliveryMethod).label;
        }

        getDeliveryStatuses(deliveryStatus: any, statuses) {
            return statuses.find(item => item.value === deliveryStatus).label;
        }

        isShowGiftCardNumber(giftCard: any): boolean {
            if (!giftCard) return;

            switch (giftCard.deliveryMethodEnum) {
                case DeliveryMethodEnum.EMail:
                    return true;
                case DeliveryMethodEnum.Mail:
                case DeliveryMethodEnum.StorePickup:
                    return !this.isEdit;
                default:
                    break;
            }
        }

        giftCardPurchasedForClientChanged(giftCardItem): void {
            if (giftCardItem && giftCardItem.purchasedForClient) {
                giftCardItem.clientId = giftCardItem.purchasedForClient.id;
                giftCardItem.clientDisplayName = giftCardItem.purchasedForClient.displayName;
            }
        }

        useAnonymousClient(item): void {
            const client = {
                id: undefined,
                clientType: Model.ClientTypeEnum.AnonymousOther,
                displayName: this.translate.instant("LABEL_ANONYMOUS_OTHER")
            };

            item.purchasedForClient = client;

            item.clientDisplayName = null;
            item.clientId = null;
        }

        showAllServicesPackages() {
            this.servicesPackagesLimitTo = this.servicesPackages.length;
        }
      
        closeAllServicesPackages() {
            this.servicesPackagesLimitTo = this.minServicesPackages;
        }

        warningDisableInput(item: any, additionalParam?: any) {
            if(!item.isRefund && (item.saleState != this.saleStateEnum.Void)) return;

            let alertMsg = '';
            if(item.isRefund) {
                if (additionalParam == 'LABEL_PURCHASED_FOR') return;
                alertMsg = 'LABEL_EGIFT_REFUNDED';
            } else if (item.saleState == SaleStateEnum.Void) {
                alertMsg = 'LABEL_EGIFT_VOIDED';
            }
            this.modalService.alert(alertMsg, Meevo.Components.Modal.ModalTranslationModes.Translate, null, {modalClass: 'white'});
        }


        isRefundOrVoid(item): string {
            if (item.saleState == SaleStateEnum.Void) return 'LABEL_VOIDED';
            if (item.isRefund) return 'LABEL_REFUNDED';
            return '';
        }

        getSaleTypeLabel(gcrd): string {
            return this.translate.instant(gcrd.saleTypeEnum == SalesTypeEnum.GiftCard ? "LABEL_GIFT_CARD_NUMBER" : "LABEL_TRANSACTION_PACKAGE_NUMBER");
        }

        filter(resetSearchOption: boolean = false): void {
            if (resetSearchOption) {
                this.request = this.defaultRequest
            }
            this.busyService.start();
            let request: EgiftTransactionsSection.ITransactionRequest = this.getRequest();
            this.transactionsInfiniteList.initSearch(request);
        }

        isGenerateCGNumber(item): boolean {
            const isAutoGenerateNumber = item.isAutoGenerateNumber
            const isGCNumberChanged = this.transItemCopy.giftCardNumber != item.giftCardNumber;
            const isBarCodeChanged = this.transItemCopy.barCode != item.barCode;

            return isAutoGenerateNumber || isGCNumberChanged || isBarCodeChanged
        }

        clearFilters(): void {
            this.filter(true);
        }

        isMobile(){
            return window.matchMedia("(max-width: 768px)").matches;
        }

        get isShowAll(): boolean {
            return this.servicesPackages.length > this.minServicesPackages && this.servicesPackagesLimitTo <= this.minServicesPackages;
        }

        get isCloseAll(): boolean {
            return this.servicesPackagesLimitTo > this.minServicesPackages
        }

        get deliveryMethodEnum(): any {
            return DeliveryMethodEnum;
        }

        get egiftPickupDeliveryStatusEnum(): any {
            return EgiftPickupDeliveryStatusEnum;
        }

        get egiftMailDeliveryStatusEnum(): any {
            return EgiftMailDeliveryStatusEnum;
        }

        get saleStateEnum(): any {
            return SaleStateEnum;
        }

        get salesTypeEnum(): any {
            return SalesTypeEnum;
        }

        checkSecurityKeysNote(key: string): ng.IPromise<SecurityAccessEnum> {
            return this.securityChecker.checkSecurityKey(key)
                .then(success => success);
        }

        get createNoteSecurityKey(): string {
            return Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_TAB_TRANSACTIONS_NOTE + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE;
        }

        get createNoteSecurityDeleteKey(): string {
            return Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_TAB_TRANSACTIONS_NOTE + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
        }

        get createNoteSecurityEditKey(): string {
            return Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_TAB_TRANSACTIONS_NOTE + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
        }

        get resendTransactionSecurityKey(): string {
            return Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_ACTION_TRANSACTIONS_RESEND + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
        }

        get resendEmailSecurityKey(): string {
            return Meevo.Components.Common.SecurityKeys.MANAGEMENT_EGIFT_ACTION_TRANSACTIONS_RESEND + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
        }

        /*
         * Override parent property. It uses for displaying an alert on navigating from Transactions tab when edit mode is turned on
         */
        get isEditing(): boolean{
            return this.isEdit;
        }

        sort(): void {
            this.request.sortBy = this.sortItem.sortBy;
            this.request.sortDirection = this.sortItem.sortDirection;
        }

        //// Transactions Data ////

        defaultFilterSettingsModel(): EgiftTransactionsSection.ITransactionsFilterSettingsReq {
            return {
                giftCardNumber: null,
                dateFrom: moment().subtract(7, 'days').toDate(),
                dateTo: moment().toDate(),
                eMail: null,
                maintenanceMode: true,
                isGlobal: true,
                isValid: null,
                finalPrice: null,
                purchasedByEmail: null,
                fullNameFrom: null,
                fullNameTo: null,
                emailDeliveryStatuses: null,
                deliveryMethodsEnum: null,
                originalAmount: null,
                withNotes: true,
                locationId: this.selectedLocationId,
                saleState: null
            }
        }

        get deliveryMethodsData(): Array<EgiftTransactionsSection.IDeliveryMethods> {
            return [
                { value: DeliveryMethodEnum.EMail, label: 'LABEL_EMAIL' },
                { value: DeliveryMethodEnum.Mail, label: 'LABEL_MAIL' },
                { value: DeliveryMethodEnum.StorePickup, label: 'LABEL_STORE_PICKUP' },
                { value: null, label: 'LABEL_SHOW_ALL' }
            ];
        }

        get emailDeliveryStatusesData(): Array<EgiftTransactionsSection.IEmailDeliveryStatuses> {
             return [
                { value: EgiftEmailDeliveryStatusEnum.DeliveryFailed, label: 'LABEL_DELIVERY_FAILED' },
                { value: EgiftEmailDeliveryStatusEnum.Sent, label: 'LABEL_SENT' }
            ];
        }

        get mailDeliveryStatusesData(): Array<EgiftTransactionsSection.IMailDeliveryStatuses> {
           return [
                { value: EgiftMailDeliveryStatusEnum.New, label: 'LABEL_NEW' },
                { value: EgiftMailDeliveryStatusEnum.InProgress, label: 'TEXT_IN_PROGRESS' },
                { value: EgiftMailDeliveryStatusEnum.ReadyToShip, label: 'LABEL_READY_TO_SHIP' },
                { value: EgiftMailDeliveryStatusEnum.Shipped, label: 'LABEL_SHIPPED' }
            ];
        }

        get pickupDeliveryStatusesData(): Array<EgiftTransactionsSection.IPickupDeliveryStatuses> {
           return [
                { value: EgiftPickupDeliveryStatusEnum.New, label: 'LABEL_NEW' },
                { value: EgiftPickupDeliveryStatusEnum.InProgress, label: 'TEXT_IN_PROGRESS' },
                { value: EgiftPickupDeliveryStatusEnum.ReadyForPickup, label: 'LABEL_READY_FOR_PICKUP' },
                { value: EgiftPickupDeliveryStatusEnum.PickedUp, label: 'LABEL_PICKED_UP' }
            ];
        }

        get sortCategoriesData(): Array<EgiftTransactionsSection.ISortCategories> {
           return [
                { sortBy: 'giftCardNumber', label: 'LABEL_NEWEST_GIFT_CARDS', sortDirection: SortDirection.Descending },
                { sortBy: 'giftCardNumber', label: 'LABEL_OLDEST_GIFT_CARDS', sortDirection: SortDirection.Ascending },
                { sortBy: 'deliveryMethodEnum', label: 'LABEL_DELIVERY_METHOD', sortDirection: SortDirection.Ascending },
                { sortBy: 'emailAddressFrom', label: 'LABEL_PURCHASED_BY', sortDirection: SortDirection.Ascending },
                { sortBy: 'fullNameTo', label: 'LABEL_RECEPIENT', sortDirection: SortDirection.Ascending },
                { sortBy: 'dateCreated', label: 'LABEL_NEWEST_PURCHASE', sortDirection: SortDirection.Descending },
                { sortBy: 'dateCreated', label: 'LABEL_OLDEST_PURCHASE', sortDirection: SortDirection.Ascending },
                { sortBy: 'deliveryStatusEnum', label: 'LABEL_STATUS', sortDirection: SortDirection.Ascending },
            ];
        }

        get defaultRequest(): EgiftTransactionsSection.ITransactionRequest {
            let mainSection = _.first(this.context.sections);
            //CHECK IF WE NEED asLocationId
            //const asLocationId = mainSection.model && !(mainSection.model.settings.requireClientToSelectLocation && mainSection.model.settings.selectedLocationWillReceiveFundsFromEgiftSales) ?
            //    mainSection.model.settings.locationId : undefined;

            return {
                criteria: this.defaultFilterSettingsModel(),
                itemsPerPage: 25, 
                sortBy: 'dateCreated',
                sortDirection: SortDirection.Descending,
                asLocationId: null//asLocationId //CHECK IF WE NEED asLocationId
            };
        }

    }

    class AdvancedFilterController {}

    angular.module('meevo.plugins.egifts')
      .controller('meevo.plugins.egifts.AdvancedFilterController', AdvancedFilterController); // Trick of empty controller to use in modal custom to reduce the number of requests for server
}
